export const ANALYTICS_EVENTS = {
  // Assistant (v1 and v2 share the same event names)
  ASSISTANT_ACTION_TAKEN: 'outlook_assistant_action_taken',
  ASSISTANT_CITATION_CLICKED: 'outlook_assistant_citation_clicked',
  ASSISTANT_FILES_UPLOADED: 'outlook_assistant_files_uploaded',
  ASSISTANT_MESSAGE_SENT: 'outlook_assistant_message_sent',
  ASSISTANT_REDLINE_ACTIVATED: 'outlook_assistant_redline_activated',
  ASSISTANT_REDLINE_REPLY_ALL_CLICKED: 'outlook_assistant_redline_reply_all_clicked',
  ASSISTANT_REDLINE_REPLY_CLICKED: 'outlook_assistant_redline_reply_clicked',
  ASSISTANT_SESSION_CREATED: 'outlook_assistant_session_created',
  ASSISTANT_SUGGESTION_CLICKED: 'outlook_assistant_suggestion_clicked',
  ASSISTANT_VOICE_TO_TEXT_ACTIVATED: 'outlook_assistant_voice_to_text_activated',
  ATTACHMENT_DOWNLOAD_TRIGGERED: 'outlook_attachment_download_triggered',
  ATTACHMENT_PREVIEW_OPENED: 'outlook_attachment_preview_opened',

  // Narrative
  CUSTOM_NARRATIVE_REPORTS_GENERATED: 'outlook_custom_narrative_reports_generated',
  NARRATIVE_COPIED: 'outlook_narrative_copied',
  NARRATIVE_EDITED: 'outlook_narrative_edited',
  NARRATIVE_SAMPLES_UPLOADED: 'outlook_narrative_samples_uploaded',
  TODAY_NARRATIVE_GENERATED: 'outlook_today_narrative_generated',
  WEEK_NARRATIVE_GENERATED: 'outlook_week_narrative_generated',

  // Profile / memory
  ASSISTANT_MEMORY_DISABLED: 'outlook_assistant_memory_disabled',
  ASSISTANT_MEMORY_ENABLED: 'outlook_assistant_memory_enabled',
  PROFILE_NARRATIVE_PREVIEW_EDITED: 'outlook_profile_narrative_preview_edited',
  PROFILE_NARRATIVE_PREVIEW_REGENERATED: 'outlook_profile_narrative_preview_regenerated',

  // Error boundaries
  ERROR_BOUNDARY_TRIGGERED: 'outlook_error_boundary_triggered',

  // Auth
  LOGIN_FAILED: 'outlook_addin_login_failed',
} as const;
